module.exports = __webpack_public_path__ + "img/logo-vivus-mexico.9c81f5fd.png";